module.exports = __webpack_public_path__ + "static/img/t36.0aea2b3b.png";